var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({attrs:{"value":_vm.value,"aria-label":_vm.ariaLabel,"type":"number"},on:{"input":_vm.onInput}},'v-text-field',_vm.$attrs,false),[(_vm.customPrependIcon)?_c('template',{slot:"prepend-inner"},[_c('img',{staticStyle:{"width":"27px","height":"22px"},attrs:{"src":_vm.customIcon,"alt":""}})]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }